import {
  ASSET_CHECKLIST,
  VALUE_NAME,
  VALUE_LABEL,
  INCOME_NAME,
  ASSET_INCOME_LABEL,
  RETIREMENT_LABEL,
  INTEREST_RATE_LABEL,
  ALT_CURRENT_BALANCE_LABEL,
  ALT_ANNUAL_ASSET_INCOME_LABEL,
  ALT_MARKET_VALUE_NAME,
  ALT_ANNUAL_INCOME_NAME,
  ALT_INTEREST_RATE_NAME,
  ALT_PROPERTY_RESIDENCE_OCCUPANCY_NAME,
  ALT_PROPERTY_RESIDENCE_OCCUPANCY_LABEL,
} from './common';

import {
  generateOnBlurAnnualIncomeCalculation,
  lowercaseFirstLetter,
} from './utils';

export const DEFAULT_ASSET_FIELDS = [
  {
    name: `${ASSET_CHECKLIST}.cashHeld`,
    label: 'Cash Held',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.cashHeld${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.cashHeld${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.checkingAccount`,
    label: 'Checking Account',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.checkingAccount${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.checkingAccount${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.savingsAccount`,
    label: 'Savings Account',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.savingsAccount${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.savingsAccount${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.payCard`,
    label: 'Pay Card',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.payCard${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.payCard${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.certificateOfDeposit`,
    label: 'Certificate of Deposit',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.certificateOfDeposit${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.certificateOfDeposit${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.trustAccount`,
    label: 'Trust Account',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.trustAccount${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.trustAccount${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.treasuryMoneyMarketFund`,
    label: 'Treasury Bills, Money Market Fund',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.treasuryMoneyMarketFund${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.treasuryMoneyMarketFund${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.stocksOrBonds`,
    label: 'Stocks or Bonds',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.stocksOrBonds${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.stocksOrBonds${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.ira`,
    label: `${RETIREMENT_LABEL} - IRA`,
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.ira${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.ira${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.pension`,
    label: `${RETIREMENT_LABEL} - Pension`,
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.pension${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.pension${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.keogh`,
    label: `${RETIREMENT_LABEL} - Keogh`,
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.keogh${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.keogh${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.k401`,
    label: `${RETIREMENT_LABEL} - 401(k)`,
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.k401${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.k401${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.otherRetirementAccount`,
    label: `${RETIREMENT_LABEL} - Other`,
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.otherRetirementAccountName`,
        label: 'Other Name',
        type: 'text',
      },
      {
        name: `${ASSET_CHECKLIST}.otherRetirementAccount${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.otherRetirementAccount${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.lifeInsurance`,
    label: 'Life insurance policy (not Term)',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.lifeInsurance${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.lifeInsurance${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.realEstate`,
    label: 'Real Estate currently owned',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.realEstate${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.realEstate${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.rentalProperty`,
    label: 'Rental Property',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.rentalProperty${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.rentalProperty${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.disposed`,
    label: 'Assets disposed of for less than Fair Market Value in past 2 years',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.disposed${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.disposed${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.disposedDate`,
        label: 'Disposed Date',
        type: 'date',
        validator: 'isValidDisposedDate',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.investmentProperties`,
    label: 'Personal Property held for investment',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.investmentProperties${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.investmentProperties${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.other`,
    label: 'Other Asset',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.otherAssetName`,
        label: 'Other Name',
        type: 'text',
      },
      {
        name: `${ASSET_CHECKLIST}.other${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.other${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
    ],
  },
];

export const ASSET_FIELDS_WITH_INT_RATE = [
  {
    name: `${ASSET_CHECKLIST}.cashHeld`,
    label: 'Cash Held',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.cashHeld${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.cashHeld${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.cashHeldInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.checkingAccount`,
    label: 'Checking Account',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.checkingAccount${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.checkingAccount${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.checkingAccountInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.savingsAccount`,
    label: 'Savings Account',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.savingsAccount${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.savingsAccount${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.savingsAccountInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.payCard`,
    label: 'Pay Card',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.payCard${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.payCard${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.payCardInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.certificateOfDeposit`,
    label: 'Certificate of Deposit',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.certificateOfDeposit${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.certificateOfDeposit${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.certificateOfDepositInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.trustAccount`,
    label: 'Trust Account',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.trustAccount${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.trustAccount${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.trustAccountInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.treasuryMoneyMarketFund`,
    label: 'Treasury Bills, Money Market Fund',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.treasuryMoneyMarketFund${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.treasuryMoneyMarketFund${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.treasuryMoneyMarketFundInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.stocksOrBonds`,
    label: 'Stocks or Bonds',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.stocksOrBonds${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.stocksOrBonds${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.stocksOrBondsInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.ira`,
    label: `${RETIREMENT_LABEL} - IRA`,
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.ira${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.ira${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.iraInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.pension`,
    label: `${RETIREMENT_LABEL} - Pension`,
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.pension${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.pension${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.pensionInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.keogh`,
    label: `${RETIREMENT_LABEL} - Keogh`,
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.keogh${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.keogh${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.keoghInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.k401`,
    label: `${RETIREMENT_LABEL} - 401(k)`,
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.k401${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.k401${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.k401InterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.otherRetirementAccount`,
    label: `${RETIREMENT_LABEL} - Other`,
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.otherRetirementAccountName`,
        label: 'Other Name',
        type: 'text',
      },
      {
        name: `${ASSET_CHECKLIST}.otherRetirementAccount${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.otherRetirementAccount${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.otherRetirementAccountInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.lifeInsurance`,
    label: 'Life insurance policy (not Term)',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.lifeInsurance${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.lifeInsurance${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.lifeInsuranceInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.realEstate`,
    label: 'Real Estate currently owned',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.realEstate${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.realEstate${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.realEstateInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.rentalProperty`,
    label: 'Rental Property',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.rentalProperty${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.rentalProperty${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.rentalPropertyInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.disposed`,
    label: 'Assets disposed of for less than Fair Market Value in past 2 years',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.disposed${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.disposed${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.disposedInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
      {
        name: `${ASSET_CHECKLIST}.disposedDate`,
        label: 'Disposed Date',
        type: 'date',
        validator: 'isValidDisposedDate',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.investmentProperties`,
    label: 'Personal Property held for investment',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.investmentProperties${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.investmentProperties${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.investmentPropertiesInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.other`,
    label: 'Other Asset',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.otherAssetName`,
        label: 'Other Name',
        type: 'text',
      },
      {
        name: `${ASSET_CHECKLIST}.other${VALUE_NAME}`,
        label: VALUE_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.other${INCOME_NAME}`,
        label: ASSET_INCOME_LABEL,
        type: 'money',
      },
      {
        name: `${ASSET_CHECKLIST}.otherInterestRate`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
      },
    ],
  },
];

export const generateLinkedAlternateFields = (
  isList,
  name,
  showHotmaPropertyResidenceQuestion = false,
  showTaxRefundAsset = false,
) => {
  const otherNameField =
    name === 'other'
      ? [
          {
            name: `${ASSET_CHECKLIST}.${name}List`,
            keyName: 'otherName',
            label: 'Other Name',
            type: 'text',
            index: 0,
          },
        ]
      : [];

  const hotmaPropertyResidenceQuestion = showHotmaPropertyResidenceQuestion
    ? [
        {
          name: `${ASSET_CHECKLIST}.${name}List`,
          keyName: lowercaseFirstLetter(ALT_PROPERTY_RESIDENCE_OCCUPANCY_NAME),
          label: ALT_PROPERTY_RESIDENCE_OCCUPANCY_LABEL,
          type: 'choice',
          index: 0,
        },
      ]
    : [];

  const isTaxRefundAsset = showTaxRefundAsset
    ? name === 'federalTaxRefundOrCredit'
    : false;

  const interestRateAnnualIncomeListFields = [
    {
      name: `${ASSET_CHECKLIST}.${name}List`,
      keyName: lowercaseFirstLetter(ALT_INTEREST_RATE_NAME),
      label: INTEREST_RATE_LABEL,
      type: 'percent',
      onBlur: generateOnBlurAnnualIncomeCalculation({
        fieldName: `${ASSET_CHECKLIST}.${name}List`,
        otherField: lowercaseFirstLetter(ALT_MARKET_VALUE_NAME),
      }),
      index: 0,
    },
    {
      name: `${ASSET_CHECKLIST}.${name}List`,
      keyName: lowercaseFirstLetter(ALT_ANNUAL_INCOME_NAME),
      label: ALT_ANNUAL_ASSET_INCOME_LABEL,
      type: 'money',
      disabled: true,
      placeholder: 'Calculated From Input',
      isControlled: true,
      index: 0,
    },
  ];

  const interestRateAnnualIncomeFields = [
    {
      name: `${ASSET_CHECKLIST}.${name}Asset${ALT_INTEREST_RATE_NAME}`,
      keyName: ALT_INTEREST_RATE_NAME,
      label: INTEREST_RATE_LABEL,
      type: 'percent',
      onBlur: generateOnBlurAnnualIncomeCalculation({
        fieldName: `${ASSET_CHECKLIST}.${name}Asset`,
        otherField: ALT_MARKET_VALUE_NAME,
      }),
    },
    {
      name: `${ASSET_CHECKLIST}.${name}Asset${ALT_ANNUAL_INCOME_NAME}`,
      keyName: ALT_ANNUAL_INCOME_NAME,
      label: ALT_ANNUAL_ASSET_INCOME_LABEL,
      type: 'money',
      disabled: true,
      placeholder: 'Calculated From Input',
      isControlled: true,
    },
  ];

  return isList
    ? [
        ...otherNameField,
        {
          name: `${ASSET_CHECKLIST}.${name}List`,
          keyName: lowercaseFirstLetter(ALT_MARKET_VALUE_NAME),
          label: ALT_CURRENT_BALANCE_LABEL,
          type: 'money',
          onBlur: generateOnBlurAnnualIncomeCalculation({
            fieldName: `${ASSET_CHECKLIST}.${name}List`,
            otherField: lowercaseFirstLetter(ALT_INTEREST_RATE_NAME),
          }),
          index: 0,
        },
        ...(!isTaxRefundAsset ? interestRateAnnualIncomeListFields : []),
        ...hotmaPropertyResidenceQuestion,
      ]
    : [
        {
          name: `${ASSET_CHECKLIST}.${name}Asset${ALT_MARKET_VALUE_NAME}`,
          keyName: ALT_MARKET_VALUE_NAME,
          label: ALT_CURRENT_BALANCE_LABEL,
          type: 'money',
          onBlur: generateOnBlurAnnualIncomeCalculation({
            fieldName: `${ASSET_CHECKLIST}.${name}Asset`,
            otherField: ALT_INTEREST_RATE_NAME,
          }),
        },
        ...(!isTaxRefundAsset ? interestRateAnnualIncomeFields : []),
      ];
};

export const ALTERNATE_ASSET_FIELDS = [
  {
    name: `${ASSET_CHECKLIST}.cashHeld`,
    keyName: 'cashHeld',
    label: 'Cash Held',
    type: 'choice',
  },
  {
    name: `${ASSET_CHECKLIST}.checkingAccount`,
    keyName: 'checkingAccount',
    canHaveMultiple: true,
    limit: 4,
    label: 'Checking Account',
    type: 'choice',
  },
  {
    name: `${ASSET_CHECKLIST}.savingsAccount`,
    canHaveMultiple: true,
    limit: 4,
    label: 'Savings Account',
    type: 'choice',
  },
  {
    name: `${ASSET_CHECKLIST}.payCard`,
    canHaveMultiple: true,
    limit: 4,
    label: 'Pay Card',
    type: 'choice',
  },
  {
    name: `${ASSET_CHECKLIST}.certificateOfDeposit`,
    canHaveMultiple: true,
    limit: 4,
    label: 'Certificate of Deposit',
    type: 'choice',
  },
  {
    name: `${ASSET_CHECKLIST}.trustAccount`,
    label: 'Trust Account',
    type: 'choice',
    canHaveMultiple: true,
    limit: 4,
  },
  {
    name: `${ASSET_CHECKLIST}.treasuryMoneyMarketFund`,
    canHaveMultiple: true,
    limit: 4,
    label: 'Treasury Bills, Money Market Fund',
    type: 'choice',
  },
  {
    name: `${ASSET_CHECKLIST}.stocksOrBonds`,
    label: 'Stocks or Bonds',
    type: 'choice',
    canHaveMultiple: true,
    limit: 4,
  },
  {
    name: `${ASSET_CHECKLIST}.ira`,
    label: `${RETIREMENT_LABEL} - IRA`,
    type: 'choice',
    canHaveMultiple: true,
    limit: 4,
  },
  {
    name: `${ASSET_CHECKLIST}.pension`,
    label: `${RETIREMENT_LABEL} - Pension`,
    type: 'choice',
    canHaveMultiple: true,
    limit: 4,
  },
  {
    name: `${ASSET_CHECKLIST}.keogh`,
    label: `${RETIREMENT_LABEL} - Keogh`,
    type: 'choice',
    canHaveMultiple: true,
    limit: 4,
  },
  {
    name: `${ASSET_CHECKLIST}.k401`,
    label: `${RETIREMENT_LABEL} - 401(k)`,
    type: 'choice',
    canHaveMultiple: true,
    limit: 4,
  },
  {
    name: `${ASSET_CHECKLIST}.otherRetirementAccount`,
    label: `${RETIREMENT_LABEL} - Other`,
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.otherRetirementAccountName`,
        label: 'Other Name',
        type: 'text',
      },
      {
        name: `${ASSET_CHECKLIST}.otherRetirementAccountAsset${ALT_MARKET_VALUE_NAME}`,
        label: ALT_CURRENT_BALANCE_LABEL,
        type: 'money',
        onBlur: generateOnBlurAnnualIncomeCalculation({
          fieldName: `${ASSET_CHECKLIST}.otherRetirementAccountAsset`,
          otherField: ALT_INTEREST_RATE_NAME,
        }),
      },
      {
        name: `${ASSET_CHECKLIST}.otherRetirementAccountAsset${ALT_INTEREST_RATE_NAME}`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
        onBlur: generateOnBlurAnnualIncomeCalculation({
          fieldName: `${ASSET_CHECKLIST}.otherRetirementAccountAsset`,
          otherField: ALT_MARKET_VALUE_NAME,
        }),
      },
      {
        name: `${ASSET_CHECKLIST}.otherRetirementAccountAsset${ALT_ANNUAL_INCOME_NAME}`,
        label: ALT_ANNUAL_ASSET_INCOME_LABEL,
        type: 'money',
        disabled: true,
        placeholder: 'Calculated From Input',
        isControlled: true,
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.lifeInsurance`,
    label: 'Life insurance policy (not Term)',
    type: 'choice',
    canHaveMultiple: true,
    limit: 4,
  },
  {
    name: `${ASSET_CHECKLIST}.realEstate`,
    label: 'Real Estate currently owned',
    type: 'choice',
    canHaveMultiple: true,
    limit: 4,
  },
  {
    name: `${ASSET_CHECKLIST}.rentalProperty`,
    label: 'Rental Property',
    type: 'choice',
    canHaveMultiple: true,
    limit: 4,
  },
  {
    name: `${ASSET_CHECKLIST}.disposed`,
    label: 'Assets disposed of for less than Fair Market Value in past 2 years',
    type: 'choice',
    linked: [
      {
        name: `${ASSET_CHECKLIST}.disposedAsset${ALT_MARKET_VALUE_NAME}`,
        label: ALT_CURRENT_BALANCE_LABEL,
        type: 'money',
        onBlur: generateOnBlurAnnualIncomeCalculation({
          fieldName: `${ASSET_CHECKLIST}.disposedAsset`,
          otherField: ALT_INTEREST_RATE_NAME,
        }),
      },
      {
        name: `${ASSET_CHECKLIST}.disposedAsset${ALT_INTEREST_RATE_NAME}`,
        label: INTEREST_RATE_LABEL,
        type: 'percent',
        onBlur: generateOnBlurAnnualIncomeCalculation({
          fieldName: `${ASSET_CHECKLIST}.disposedAsset`,
          otherField: ALT_MARKET_VALUE_NAME,
        }),
      },
      {
        name: `${ASSET_CHECKLIST}.disposedAsset${ALT_ANNUAL_INCOME_NAME}`,
        label: ALT_ANNUAL_ASSET_INCOME_LABEL,
        type: 'money',
        disabled: true,
        placeholder: 'Calculated From Input',
        isControlled: true,
      },
      {
        name: `${ASSET_CHECKLIST}.disposedDate`,
        label: 'Disposed Date',
        type: 'date',
        validator: 'isValidDisposedDate',
      },
    ],
  },
  {
    name: `${ASSET_CHECKLIST}.investmentProperties`,
    label: 'Personal Property held for investment',
    type: 'choice',
    canHaveMultiple: true,
    limit: 4,
  },
  {
    name: `${ASSET_CHECKLIST}.other`,
    label: 'Other Asset',
    type: 'choice',
    canHaveMultiple: true,
    limit: 10,
  },
  {
    name: `${ASSET_CHECKLIST}.federalTaxRefundOrCredit`,
    label: 'Federal Tax Refund/Credit',
    type: 'choice',
    canHaveMultiple: true,
    limit: 4,
    tooltip: {
      type: 'INFO',
      title:
        'Tax refunds and credits will be deducted from the net cash value of assets.',
    },
  },
];

export const ALT_ASSET_FORM_FIELD_NAMES = ALTERNATE_ASSET_FIELDS.filter(
  (field) => !field.canHaveMultiple,
).map((field) => {
  return field.name.split('.')[1];
});
